/**
 * Marquee: lo scorrimento è una CSS animation sul compositor.
 * Il JS serve solo a misurare quanti cloni servono per coprire lo schermo
 * e a tradurre la velocità (px/frame) in una durata dell'animazione.
 */
class TdsMarquee extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.tds-marquee__track');
    this.group = this.querySelector('.tds-marquee__group');
    if (!this.track || !this.group) return;

    // ResizeObserver emette subito la prima misura: niente chiamata iniziale.
    this.observer = new ResizeObserver(() => this.layout());
    this.observer.observe(this);
    // il font custom cambia la larghezza dei testi dopo il primo render
    if (document.fonts) document.fonts.ready.then(() => this.layout());
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  layout() {
    this.track.querySelectorAll('[data-clone]').forEach((el) => el.remove());

    const distance = this.group.offsetWidth;
    if (!distance) return;

    for (let i = Math.ceil(this.offsetWidth / distance) + 1; i > 0; i--) {
      const clone = this.group.cloneNode(true);
      clone.dataset.clone = '';
      clone.setAttribute('aria-hidden', 'true');
      this.track.append(clone);
    }

    const speed = parseFloat(this.dataset.speed) || 0.2; // px per frame a 60fps, come node-marquee
    this.style.setProperty('--marquee-distance', `${distance}px`);
    this.style.setProperty('--marquee-duration', `${distance / (speed * 60)}s`);
  }
}

if (!customElements.get('tds-marquee')) customElements.define('tds-marquee', TdsMarquee);
